import {useLocation} from 'react-router-dom'
import {useSharedStore} from '../state/shared-store-context'
import {effect} from '../shared/effect'
import {
    getFooterColor,
    getFooterContent,
    getFooterProfile,
    getFooterPosition,
    getFooterRightContainerContent,
    getFlipToolbarVertically,
    getHeaderContent,
    getHeaderProfile,
    getHeaderLeftContainerContent,
    getHeaderRightContainerContent,
    getHeaderPosition,
    getNoHideFooter,
    getNoHideHeader,
    getNoHideToolbar,
    getToolbarContent,
    getToolbarPosition,
    getTransparentToolbars,
    columnConfig,
} from '../shared/layout-dynamics'
import {useIsMobile} from './use-is-mobile'

export function useLayoutDynamics() {
    const location = useLocation()
    const {sharedState, actions} = useSharedStore()
    const hasLocationFrom = !!location.state?.from
    const isMobile = useIsMobile()

    effect([location.pathname, location.search, hasLocationFrom, sharedState.editMode, sharedState.portfolioMode,
        sharedState.sessionStatus, isMobile], () => {
        const path = location.pathname + location.search
        const columnCount = columnConfig[Object.keys(columnConfig).find(key => path.startsWith(key.split('*')[0])
            && (!key.split('*')[1] || path.endsWith(key.split('*')[1])))]
        actions.setFooter({
            position: getFooterPosition(path),
            profile: getFooterProfile(location.pathname),
            content: getFooterContent(location.pathname, sharedState, {isMobile}),
            rightContainerContent: getFooterRightContainerContent(location.pathname),
            color: getFooterColor(location.pathname),
            columnCount,
        })
        actions.setHeader({
            position: getHeaderPosition(path, {hasLocationFrom}),
            profile: getHeaderProfile(location.pathname),
            content: getHeaderContent(location.pathname),
            leftContainerContent: getHeaderLeftContainerContent(location.pathname),
            rightContainerContent: getHeaderRightContainerContent(location.pathname),
            columnCount,
        })
        actions.setToolbar({
            position: getToolbarPosition(path),
            flipVertically: getFlipToolbarVertically(path),
            content: getToolbarContent(location.pathname, {hasLocationFrom}),
            columnCount,
        })
        actions.setNoHideHeader(getNoHideHeader(path))
        actions.setNoHideFooter(getNoHideFooter(path))
        actions.setNoHideToolbar(getNoHideToolbar(path))
        actions.setTransparentToolbars(getTransparentToolbars(path))
    })
}
